import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import NavigationBar from "../components/NavigationBar.js";
import seriesStore from "../stores/seriesStore.js";
import statusStore from "../stores/statusStore.js";
import seasonStore from "../stores/seasonStore.js"
import Header from "../components/Header.js";
import Footer from "../components/Footer.js";
import MobileEpisodeReview from "../components/MobileComponents/MobileEpisodeReview";
import StatusDropdown from "../components/SeriesComponents/StatusDropdown";
import AdSection from "../components/SeriesComponents/AdSection";
import Episodes from "../components/SeriesComponents/Episodes";


export default function SeriesPage() {
    const location = useLocation();
    
    const serStore = seriesStore();
    const staStore = statusStore();
    const seaStore = seasonStore();

    const [selectedShow, setSelectedShow] = useState(null);
    const [selectedSeriesList, setSelectedSeriesList] = useState(null);
    const [activeHeader, setActiveHeader] = useState(false);

    const [navOpen, setNavOpen] = useState(null);

    // Runs the function on load
    useEffect(() => {
        serStore.fetchSeries();
        staStore.fetchStatus();
        seaStore.fetchSeason();
    }, []);

    useEffect(() => {
        if (!selectedShow?._id) return;
    }, [selectedShow?._id, staStore.status]);

    useEffect(() => {
        if (location.state?.selectedShow) {
            setSelectedShow(location.state.selectedShow);
            console.log("selected show = " + selectedShow?.title);
        }
    }, [location.state]);

    const currentStatus = staStore.status?.find((s) => s.seriesId === selectedShow?._id)?.userStatus || ""; // series userStatus

    const [selectedSeason, setSelectedSeason] = useState(1);
    const [reviewOverlayOpen, setReviewOverlayOpen] = useState(false);
    
    useEffect(() => {
        staStore.fetchStatus();
        setSelectedSeason(1);
    }, [selectedShow]);
    
    const [statusDDOpen, setStatusDDOpen] = useState(false); // for the status dropdown
    const [seasonDDOpen, setSeasonDDOpen] = useState(false); // for the season dropdown

    const statusRef = useRef(null);
    const seasonRef = useRef(null);

     // Close dropdowns if clicked outside
    useEffect(() => {
        const handleClickOutside = (event) => {
        if (statusRef.current && !statusRef.current.contains(event.target)) {
            setStatusDDOpen(false);
        }
        if (seasonRef.current && !seasonRef.current.contains(event.target)) {
            setSeasonDDOpen(false);
        }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
        document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

     // Scroll past the header on mobile
    useEffect(() => {
        if (window.innerWidth <= 768) {
            window.scrollTo({ top: 90, behavior: 'auto' });
        }
    }, []);

    return (
        <div className="app-wrapper tv-static">
            <header class="header">
                <Header 
                    selectedShow={selectedShow}
                    setSelectedShow={setSelectedShow}
                    selectedSeriesList={selectedSeriesList}
                    setSelectedSeriesList={setSelectedSeriesList}
                    activeHeader={activeHeader}
                    setActiveHeader={setActiveHeader}
                />
            </header>
            <content className="content">
                <nav className="nav">
                    <NavigationBar 
                    selectedShow={selectedShow}
                    setSelectedShow={setSelectedShow}
                    selectedSeriesList={selectedSeriesList}
                    setSelectedSeriesList={setSelectedSeriesList}
                    activeHeader={activeHeader}
                    setActiveHeader={setActiveHeader}
                    />
                </nav>
                <main className="main">
                  
                    {selectedShow ? (
                         <div className="midSection">
                            <div className="coverImageFade">
                                <div className="coverImage" 
                                style={{
                                    backgroundImage: `url('${selectedShow?.fanart}')`,
                                }}>
                                </div>
                            </div>
                            <div className="midSectionHeader" >  
                                <h2 className="showTitle">{selectedShow.title}</h2>
                                <div className="seriesInfoDetailsRow">
                                    <p className="seriesInfoYear">{selectedShow.year}</p>
                                    <p className="seriesInfoDetails">{selectedShow.numberOfSeasons} season{selectedShow.numberOfSeasons != 1 && <span>s</span>}</p>
                                    <p className="seriesInfoGenres">{selectedShow.genres?.join(", ")}</p>
                                </div>
                                <div className="seriesInfoDetailsRow"><p className="seriesInfoOverview">{selectedShow.overview}</p></div>
                                <div className="seriesInfoStatusDropdown" ref={statusRef}>
                                    <StatusDropdown
                                        selectedShow={selectedShow}
                                        currentStatus={currentStatus}
                                        statusDDOpen={statusDDOpen}
                                        setStatusDDOpen={setStatusDDOpen}/>
                                </div>
                                <hr></hr>
                                <div className="seriesInfoRow2"><img
                                        src={`/assets/companyLogos/${selectedShow.network}.png`}
                                        alt={selectedShow.network + " logo"}
                                        className="logoImg"
                                        onError={(e) => {
                                            const span = document.createElement("span");
                                            span.textContent = selectedShow.network;
                                            span.className = "seriesInfoDetails";
                                            e.currentTarget.replaceWith(span);
                                        }}
                                    />
                                    <p className="seriesInfoDetails">{selectedShow.originalCountry}, {selectedShow.originalLanguage}</p>
                                    <p className="seriesInfoDetails">{selectedShow.airingStatus}</p>
                                </div>
                                <hr></hr>
                            </div>
                            <div className="adSection">
                                <AdSection></AdSection>
                            </div>
                            <div className="midAlignmentDiv">
                                <div>
                                <div className="seasonDropdownWrapper" ref={seasonRef}>
                                    {selectedShow.numberOfSeasons != 1 && <div>
                                        <button type="button" onClick={() => setSeasonDDOpen(!seasonDDOpen)} className="seasonDropdown"> 
                                            Season {selectedSeason}
                                            <span className="dropdown-arrow">&#9662;</span>
                                        </button>
                                        {seasonDDOpen && (
                                            <ul className="seasonDropdownMenu">
                                            {Array.from({ length: selectedShow.numberOfSeasons }, (_, i) => (
                                                <li
                                                key={i}
                                                className={`dropdown-item ${i === selectedSeason ? "selected" : ""}`}
                                                onClick={() => { 
                                                        setSelectedSeason(i + 1); 
                                                        setSeasonDDOpen(false); 
                                                    }
                                                }
                                                >
                                                Season {i + 1}
                                                </li>
                                            ))}
                                            </ul>
                                        )}
                                    </div>}
                                    {selectedShow.numberOfSeasons == 1 && <div>
                                        <button type="button" className="seasonHeader"> 
                                            Season {selectedSeason}
                                        </button>
                                    </div>}
                                </div>
                                <div>
                                    {/* <button type="button" onClick={() => setReviewOverlayOpen(true)}> 
                                        Leave a review
                                    </button> */}
                                </div>
                
                                <Episodes
                                    selectedShow={selectedShow}
                                    selectedSeason={selectedSeason}
                                ></Episodes>       
                                
                            </div>
                
                            {reviewOverlayOpen && 
                                <MobileEpisodeReview 
                                    reviewOverlayOpen={reviewOverlayOpen}
                                    setReviewOverlayOpen={setReviewOverlayOpen}
                                ></MobileEpisodeReview>}
                
                            <div className="clearStyleDiv"></div>
                                    
                                </div>
                            </div>
                    ): ""}
                </main>
                <aside className="right">
                    <div className="rightPanel">
                    </div>
                </aside>
            </content>
            <div class="footer"><Footer/></div>
        </div>
    )
}